
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { WorldCountry } from '@/data/countries/types';
import { worldCountries } from '@/data/countries/index';

interface CountryRelatedSectionProps {
  country: WorldCountry;
}

const CountryRelatedSection = ({ country }: CountryRelatedSectionProps) => {
  return (
    <div className="mt-12">
      <h3 className="text-xl font-semibold text-brand-gray-900 mb-4">
        Explore Best Psychotherapists in Other Countries
      </h3>
      <p className="text-brand-gray-700 mb-6">
        Looking for the best psychotherapists in other countries? Browse our international 
        directory to find qualified mental health professionals worldwide.
      </p>
      <div className="flex flex-wrap gap-2">
        {worldCountries
          .filter(c => c.slug !== country.slug)
          .slice(0, 10)
          .map(c => (
            <Link 
              key={c.code}
              to={`/psychologists/${c.slug}`}
              className="text-sm bg-brand-gray-100 hover:bg-brand-gray-200 px-3 py-1 rounded-full text-brand-gray-800 transition-colors"
              aria-label={`View best psychotherapists in ${c.name}`}
            >
              Best Psychotherapists in {c.name}
            </Link>
          ))
        }
        <Link 
          to="/directory"
          className="text-sm bg-brand-blue-100 hover:bg-brand-blue-200 px-3 py-1 rounded-full text-brand-blue-800 transition-colors flex items-center"
        >
          View All Countries
          <ChevronRight className="h-3 w-3 ml-1" />
        </Link>
      </div>
    </div>
  );
};

export default CountryRelatedSection;
